<div class="c-menu-list" [ngClass]="cssClass">
  <div class="c-menu-list__title" i18n="@@common.profile_panel">Profile panel</div>
  <div class="c-menu-list__content">
    <li class="c-menu-list__item">
      <p500-ui-slide-toggle-field [formControl]="supportChatControl" [isLabelRight]="true" size="medium">
        <ng-template p500UIFieldLabel>
          <small class="c-menu-list__label" i18n="@@common.support_chat">Support Chat</small>
        </ng-template>
      </p500-ui-slide-toggle-field>
    </li>
    <li class="c-menu-list__item">
      <p500-ui-slide-toggle-field [formControl]="unsecuredModeControl" [isLabelRight]="true" size="medium">
        <ng-template p500UIFieldLabel>
          <small class="c-menu-list__label" i18n="@@common.unsecured_mode">Unsecured Mode</small>
        </ng-template>
      </p500-ui-slide-toggle-field>
    </li>
    <div class="c-menu-list__item" *ngIf="affManagerId">
      <a [routerLink]="['/app/settings/crm-affiliate-manager/' + affManagerId]" class="d-flex">
        <p500-ui-icon name="pencil h-icon"> </p500-ui-icon>
        <span i18n="@@common.edit_contacts">Edit Contacts</span>
      </a>
    </div>
    <div class="c-menu-list__item">
      <a [href]="controlLink" target="_blank" class="d-flex">
        <p500-ui-icon name="pencil h-icon"> </p500-ui-icon>
        <span i18n="@@common.edit_profile">Edit Profile</span>
      </a>
    </div>
    <div class="c-menu-list__item -red" (click)="logout()">
      <p500-ui-icon name="log-out h-icon"> </p500-ui-icon>
      <span i18n="@@common.go_to_id">Go to ID</span>
    </div>
  </div>
</div>
